import React from 'react';
import classNames from 'classnames';

interface SpinnerProps {
  // Shown while true. Defaults to true, as Bronson's did, so a bare
  // <Spinner fullPage /> is a loading screen.
  busy?: boolean;
  fullPage?: boolean;
  testId?: string;
  className?: string;
}

export function Spinner({ busy = true, fullPage, testId, className }: SpinnerProps) {
  return (
    <div
      data-testid={testId}
      aria-live="polite"
      aria-busy={busy}
      className={classNames('ec-spinner', fullPage && 'ec-spinner--full-page', className)}
    >
      <span className="ec-spinner__wheel" />
    </div>
  );
}
